import { render } from "./addProductDrawer.vue?vue&type=template&id=4622a34f"
import script from "./addProductDrawer.vue?vue&type=script&lang=js"
export * from "./addProductDrawer.vue?vue&type=script&lang=js"

import "./addProductDrawer.vue?vue&type=style&index=0&id=4622a34f&lang=scss"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/componentsBusiness/addProductDrawer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4622a34f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4622a34f', __exports__)) {
    api.reload('4622a34f', __exports__)
  }
  
  module.hot.accept("./addProductDrawer.vue?vue&type=template&id=4622a34f", () => {
    api.rerender('4622a34f', render)
  })

}


export default __exports__